module.exports = __webpack_public_path__ + "static/img/feature_05.da990a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/ares/secondAnniversary/3/feature_05.png
// module id = 2Nyx
// module chunks = 10